import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => {
  const pageBackground = theme.palette.grey[400];

  return {
    container: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: pageBackground,
      direction: "rtl",
      overflow: "hidden",
    },

    contentWrapper: {
      flex: 1,
      minWidth: 0,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      background: pageBackground,
      overflow: "hidden",
    },

    topbarWrapper: {
      width: "100%",
      flexShrink: 0,
      position: "sticky",
      top: 0,
      zIndex: 100,
      background: theme.palette.background.paper,
    },

    scrollContent: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      padding: 0,
      boxSizing: "border-box",
      background: pageBackground,
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },

    pageContent: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      opacity: 1,
      marginTop: 10,
      marginLeft: 24,
      marginRight: 24,
      marginBottom: 24,
      boxSizing: "border-box",
    },

    tableContainer: {
      width: "100%",
      background: pageBackground,
      "& > div": {
        overflow: "auto !important",
        overflowX: "auto !important",
        overflowY: "auto !important",
        WebkitOverflowScrolling: "touch",
      },
    },
  };
});
